function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVivaEngage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear0",
  gradientUnits: "userSpaceOnUse",
  x1: 6,
  y1: 31.3333,
  x2: 13.046,
  y2: -2.05664,
  gradientTransform: "matrix(0.375,0,0,0.375,0,0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "rgb(1.960784%,20%,46.666667%)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "rgb(18.431373%,56.862745%,94.901961%)",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear1",
  gradientUnits: "userSpaceOnUse",
  x1: 53.361,
  y1: 4.95462,
  x2: 37.3333,
  y2: 29,
  gradientTransform: "matrix(0.375,0,0,0.375,0,0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "rgb(29.019608%,75.686275%,100%)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.926632,
  style: {
    stopColor: "rgb(8.235294%,36.862745%,70.980392%)",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear2",
  gradientUnits: "userSpaceOnUse",
  x1: 27.6667,
  y1: 14.3333,
  x2: 43.3333,
  y2: 45.3333,
  gradientTransform: "matrix(0.375,0,0,0.375,0,0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "rgb(58.823529%,87.45098%,100%)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.413439,
  style: {
    stopColor: "rgb(32.54902%,67.843137%,93.333333%)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "rgb(0%,41.960784%,72.54902%)",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear3",
  gradientUnits: "userSpaceOnUse",
  x1: 40.2264,
  y1: 38.8504,
  x2: 57.1203,
  y2: 66.9453,
  gradientTransform: "matrix(0.375,0,0,0.375,0,0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0799194,
  style: {
    stopColor: "rgb(29.019608%,75.686275%,100%)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "rgb(8.235294%,36.862745%,70.980392%)",
    stopOpacity: 1
  }
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear4",
  gradientUnits: "userSpaceOnUse",
  x1: 6.64196,
  y1: 27.7693,
  x2: 22.512,
  y2: 65.9607,
  gradientTransform: "matrix(0.375,0,0,0.375,0,0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "rgb(18.431373%,56.862745%,94.901961%)",
    stopOpacity: 1
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "rgb(1.960784%,20%,46.666667%)",
    stopOpacity: 1
  }
}))), /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#linear0)"
  },
  d: "M 6 0 C 9.3125 0 12 2.6875 12 6 L 12 13.5 L 0 13.5 L 0 6 C 0 2.6875 2.6875 0 6 0 Z M 6 0 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#linear1)"
  },
  d: "M 18 0 C 14.6875 0 12 2.6875 12 6 L 12 13.5 L 24 13.5 L 24 6 C 24 2.6875 21.3125 0 18 0 Z M 18 0 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#linear2)"
  },
  d: "M 18 9.75 C 18 6.4375 15.3125 3.75 12 3.75 C 8.6875 3.75 6 6.4375 6 9.75 C 6 13.0625 8.6875 15.75 12 15.75 C 15.3125 15.75 18 13.0625 18 9.75 Z M 18 9.75 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#linear3)"
  },
  d: "M 24 6 C 24 5.960938 24 5.921875 24 5.882812 L 23.996094 5.882812 C 23.847656 9.378906 20.75 12.195312 16.875 12.367188 L 16.875 12.375 C 13.5625 12.375 10.875 14.976562 10.875 18.1875 C 10.875 21.398438 13.5625 24 16.875 24 L 16.910156 24 C 22.878906 23.976562 24 18.105469 24 15.375 Z M 24 6 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "url(#linear4)"
  },
  d: "M 0 15.375 C 0 18.105469 1.121094 23.976562 7.089844 24 L 7.125 24 C 10.4375 24 13.125 21.398438 13.125 18.1875 C 13.125 14.976562 10.4375 12.375 7.125 12.375 L 7.125 12.367188 C 3.25 12.195312 0.152344 9.378906 0.00390625 5.882812 L 0 5.882812 C 0 5.921875 0 5.960938 0 6 Z M 0 15.375 "
})));
export { SvgVivaEngage as ReactComponent };
export default __webpack_public_path__ + "static/media/vivaEngage.65f8d742.svg";